import { CheckoutState } from '../../state';
import { getFirstNameToPrefill } from '../../utils/user';
import { getBuyerFirstNameFromSurveyData } from '../forms';

export const getFirstNameToPrefillFirstAttendeeInfo = (state: CheckoutState) =>
    getBuyerFirstNameFromSurveyData(state) || getFirstNameToPrefill(state);
